/**
*
* PopupLink
*
*/

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

const Iframe = styled.iframe`
  width: 100%;
  height: calc(100vh - 150px);
  border: none;
  margin-bottom: 8px;
`;

function PopupLink(props) {
  const { id, title } = props;
  const [link, setLink] = useState('');
  useEffect(() => {
    const target = document.getElementById(id);
    if (!target) {
      return () => {};
    }
    const listener = (ev) => {
      if (ev.ctrlKey || ev.shiftKey) {
        return;
      }
      const { href } = target;
      if (href) {
        ev.preventDefault();
        setLink(href);
      }
    };
    target.addEventListener('click', listener);
    return () => {
      target.removeEventListener('click', listener);
    };
  }, []);
  return (
    <Modal show={Boolean(link)} bsSize="large" onHide={() => setLink('')}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Iframe title={title} src={link} />
    </Modal>
  );
}

PopupLink.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default PopupLink;
